import { render, staticRenderFns } from "./SurfaceDesignColors.vue?vue&type=template&id=fb21a340"
import script from "./SurfaceDesignColors.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignColors.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignColors.vue?vue&type=style&index=0&id=fb21a340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports